<template>
    <section class="hashtag-section _preview-section" v-if="$store.state.register.form.hashtag.length > 0">
        <div class="section-inner">
            <h2 class="heading-section"><span>Hashtags</span></h2>
            <div class="hashtag-item-wrap">

                    <a class="btn_common" v-for="(hashtag, index) in $store.state.register.form.hashtag" v-bind:key="index" style="pointer-events: none;">
                        <div class="md_svg-icon">
                            <SvgIconHashTag />
                        </div>
                        <span>{{ hashtag }}</span>
                        <div class="number" v-if="hashtag.count"><span>{{hashtag.count}}</span></div>
                    </a>

            </div>
        </div><!--/.section-inner-->
    </section>
</template>

<script>
    import SvgIconHashTag from '@/components/EndUser/svg/SvgIconHashTag'

    export default {
        components: {
            SvgIconHashTag,
        },
    }
</script>